import { useTranslation } from 'react-i18next'

import { useValidationWithoutFormikNotifications } from '../../../../hooks'
import {
  useTableModalCloseHandler,
  useTableModalLoadingData,
} from '../../../TableModal'
import { getDocFlowSelectModalItems } from '../../DocFlowSelectModal.api'
import {
  getDocFlowSelectModalInitialNotifications,
  getDocFlowSelectModalItemsFromResponse,
  getDocFlowSelectModalRequestParams,
  getDocFlowSelectModalTableColumns,
  isDocFlowSelectModalSelectionEmpty,
} from '../../DocFlowSelectModal.utils'

export function useDocFlowSelectModal({
  entityId,
  excludeIds,
  loadItems = getDocFlowSelectModalItems,
  showLimitNotification,
  onAttach,
  onClose,
}) {
  const { t } = useTranslation()

  async function getItems(id, params) {
    return loadItems({ excludeIds, id, params })
  }

  const loadData = useTableModalLoadingData({
    entityId,
    getItemsFromResponse: getDocFlowSelectModalItemsFromResponse,
    getRequestParams: getDocFlowSelectModalRequestParams,
    initialNotifications: getDocFlowSelectModalInitialNotifications({
      showLimitNotification,
      t,
    }),
    loadItems: getItems,
  })

  const {
    handlePrependNotification,
    handleRemoveNotification,
    initialSelectionValues,
    selected,
    setLoading,
  } = loadData

  const { handleCloseTableModal, isCloseConfirm, setCloseConfirm } =
    useTableModalCloseHandler({
      initialSelectionValues,
      selected,
      onClose,
    })

  const { isValidForm, setNotificationListRef } =
    useValidationWithoutFormikNotifications({
      validationSchemaProps: {
        isEqual: isDocFlowSelectModalSelectionEmpty,
        isEqualProps: { selected },
      },
      onRemoveNotification: handleRemoveNotification,
      onSetNotification: handlePrependNotification,
    })

  // `onAttach` resolves the request; the caller decides whether the modal
  // closes, so an error can keep it open with its notification.
  function handleAttach() {
    if (!onAttach) {
      onClose()

      return
    }

    if (isValidForm()) {
      setLoading(true)

      onAttach({ id: entityId, selected }).finally(() => setLoading(false))
    }
  }

  const tableColumns = getDocFlowSelectModalTableColumns()

  return {
    handleAttach,
    handleCloseTableModal,
    isCloseConfirm,
    loadData,
    setCloseConfirm,
    setNotificationListRef,
    tableColumns,
  }
}
